// Self-contained auth for the marketing website admin (independent of the product app).
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/marketing`;
const TOKEN_KEY = 'bp_marketing_token';

export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch (e) { return null; }
};
export const setToken = (t) => {
  try { localStorage.setItem(TOKEN_KEY, t); } catch (e) { /* noop */ }
};
export const clearToken = () => {
  try { localStorage.removeItem(TOKEN_KEY); } catch (e) { /* noop */ }
};
export const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export async function apiLogin(email, password, captchaToken) {
  return (await axios.post(`${API}/auth/login`, { email, password, captcha_token: captchaToken || '' })).data;
}
export async function apiVerifyOtp(email, otp) {
  return (await axios.post(`${API}/auth/verify-otp`, { email, otp })).data;
}
export async function apiMe() {
  return (await axios.get(`${API}/auth/me`, { headers: authHeaders() })).data;
}
export async function apiLogout() {
  try { await axios.post(`${API}/auth/logout`, {}, { headers: authHeaders() }); } catch (e) { /* noop */ }
}

export function formatApiError(detail, fallback = 'Something went wrong. Please try again.') {
  if (detail == null) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}
